// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yrV8xV8r3oegXDlD{position:absolute;right:4px;margin-top:-6px}.iY1SvaOyN5U0Z1o0{display:flex;justify-content:center;align-items:center;height:100%}.LBCQIv3_0cYuAHl4{display:grid;grid-template-columns:32px 1fr}.LBCQIv3_0cYuAHl4.y7fHrO4glBsbvcNC{grid-template-columns:34px 32px 1fr}.LBCQIv3_0cYuAHl4 .hLwkn5mNfQQqDqpb{display:flex;flex-direction:column;justify-content:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.LBCQIv3_0cYuAHl4 .hLwkn5mNfQQqDqpb.Jv2BSXQ60Inqe3mI{max-width:200px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deleteButton": `yrV8xV8r3oegXDlD`,
	"loading": `iY1SvaOyN5U0Z1o0`,
	"nameColumn": `LBCQIv3_0cYuAHl4`,
	"addEmployees": `y7fHrO4glBsbvcNC`,
	"employeeName": `hLwkn5mNfQQqDqpb`,
	"shortened": `Jv2BSXQ60Inqe3mI`
};
export default ___CSS_LOADER_EXPORT___;
